// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iconUser {
    width: 30px;
    height: 30px;
    padding: 0px 8px;
}

.containerModalProfile {
    display: flex;
    align-items: center;
    cursor: pointer;
    justify-content: center;
}

.nameProfile {
    font-size: 15px;
    font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/componentes/profile/profile.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB","sourcesContent":[".iconUser {\n    width: 30px;\n    height: 30px;\n    padding: 0px 8px;\n}\n\n.containerModalProfile {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    justify-content: center;\n}\n\n.nameProfile {\n    font-size: 15px;\n    font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
